import {useMutation, useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';
import {invalidateQueryV2} from '../services/reactQuery';

export const useGetCandidatesQuery = (params) => {
  return useQuery(['candidateJobs', params], async () => {
    const {data} = await axiosClient.get('/candidates', {
      params,
    });
    return data;
  });
};

export const useGetCandidateJobDetailsQuery = (jobId) => {
  return useQuery(
    ['candidateJobDetails', jobId],
    async () => {
      const {data} = await axiosClient.get(`candidate/${jobId}`);
      return data;
    },
    {
      enabled: !!jobId,
    },
  );
};

export const useRemoveCandidateFromJobMutation = () =>
  useMutation(
    async (jobId) => {
      const {data} = await axiosClient.delete(`candidate/${jobId}`);
      return data;
    },
    {
      onSuccess: () => invalidateQueryV2('candidateJobs'),
    },
  );

export const useCanidateJobUpdateMutation = () =>
  useMutation(
    async ({jobId, payload}) => {
      const {data} = await axiosClient.patch(`candidate/${jobId}`, payload);
      return data;
    },
    {
      onSuccess: () => invalidateQueryV2('candidateJobs'),
    },
  );

/**
 *
 * Skills
 *
 */

export const useGetSkillsQuery = () => {
  return useQuery(['skills'], async () => {
    const {data} = await axiosClient.get('/skill');
    return data;
  });
};

export const useAddSkillMutation = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post('/skill', payload);
    return data;
  });

export const useUpdateSkillMutation = () =>
  useMutation(async ({skillId, ...payload}) => {
    const {data} = await axiosClient.put(`skill/${skillId}`, payload);
    return data;
  });

export const useDeleteSkillMutation = () =>
  useMutation(async (skillId) => {
    const {data} = await axiosClient.delete(`skill/${skillId}`);
    return data;
  });
